var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form archive-detail-popup"
  }, [_c('div', {
    staticClass: "content-form-popup archive-detail-content"
  }, [_c('div', {
    staticClass: "archive-detail-header"
  }, [_c('button', {
    staticClass: "detail-back",
    attrs: {
      "type": "button",
      "aria-label": "Späť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("‹")]), _vm._m(0)]), _c('div', {
    staticClass: "detail-choice-list"
  }, _vm._l(_vm.detailChoices, function (choice) {
    return _c('button', {
      key: choice.value,
      staticClass: "detail-choice",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.finishArchive(choice.value);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(choice.label))]), _c('span', {
      staticClass: "detail-check"
    }, [_vm._v("✓")])]);
  }), 0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', [_vm._v("Iný dôvod neúspechu")]), _c('h2', [_vm._v("Čo konkrétne rozhodlo?")]), _c('p', [_vm._v("Tento detail sa zobrazí v štatistikách dôvodov archivácie.")])]);

}]

export { render, staticRenderFns }